var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{attrs:{"id":"main"}},[_c('BreadCrumbs',{attrs:{"pagename":_vm.$t('price.main')}}),_c('Pricing')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }